// firestoreService.js
import { db } from "./firebase"; // your config
import {
  doc,
  setDoc,
  updateDoc,
  onSnapshot,
  serverTimestamp,
} from "firebase/firestore";
const envPrefix = process.env.REACT_APP_ENV || "";
const COLLECTION_NAME = `${envPrefix}needle_eye_sync`;

export const createSession = async (documentId, data) => {
  await setDoc(doc(db, COLLECTION_NAME, documentId), {
    ...data,
    created_at: serverTimestamp(),
    updated_at: serverTimestamp(),
  });
};

export const updateSession = async (documentId, data) => {
  await setDoc(
    doc(db, COLLECTION_NAME, documentId),
    {
      status: data.status,
      updated_at: serverTimestamp(),
    },
    { merge: true },
  );
};

export const listenSession = (documentId, callback) => {
  return onSnapshot(doc(db, COLLECTION_NAME, documentId), (docSnap) => {
    if (docSnap.exists()) {
      callback(docSnap.data());
    }
  });
};
